import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core'
import { RequestsService } from '../../_shared/services/requests.service'
import { AuthenticationService } from '../../_services/authentication.service'
import { HelperFunctions } from '../../_shared/utils/helper-functions'
import { FormGroup, FormBuilder, FormArray } from '@angular/forms'
import * as moment from 'moment'

declare var jQuery: any

@Component({
  selector: 'app-village-agents',
  templateUrl: './village-agents.component.html',
  styleUrls: ['./village-agents.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class VillageAgentsComponent implements OnInit {
  bulkPaymentForm: FormGroup

  constructor(
    private requestService: RequestsService,
    private authenticationService: AuthenticationService,
    private helperFunctions: HelperFunctions,
    private fb: FormBuilder
  ) {}

  @ViewChild('calendar') private calendar: any

  isLoadingCommissions: boolean
  model: any
  agentsCommissionsData: any
  countryName: string
  agentsCommissionsDataFilter: any
  upPage = 1
  pPage = 1
  thPage = 1
  count = 10
  searchItem: string
  loading: boolean
  singleAgentCommissionsData: any
  agentId: string
  agentsName: string
  agentMomoName: string
  agentMomoPhone: string
  status: string
  message: string
  isMakingPayment: boolean
  isLoadingPayments: boolean
  paymentsData: any
  paymentsDataFilter: any
  totalAmount: number
  totalPayments: number
  transactionHistoryDataFilter: any
  transactionHistoryData: any
  isLoadingTransHistory: boolean
  commissionAmount: number
  rangeDates: Date[]
  amountError: string
  bulkPaymentsData: any[] = []
  agrishopOrderTransactions: any[] = []
  gardenMappingTransactions: any[] = []
  paymentTransactions: any[] = []
  isPaymentTrans: boolean
  isGardenMappingTrans: boolean
  interval: any

  ngOnInit() {
    const currentUser = this.authenticationService.getCurrentUserValue()
    const { country } = currentUser
    this.countryName = country
    this.model = {}
    this.bulkPaymentForm = this.fb.group({
      bulk_payments: this.fb.array([]),
    })
    this.loadCommissions()
    this.loadCompletedPayments()
    this.interval = setInterval(() => {
      this.loadCommissions()
      this.loadCompletedPayments()
      // console.log("interval has fired");
    }, 1800000)
  }

  commissionPayments(): FormArray {
    return this.bulkPaymentForm.get('bulk_payments') as FormArray
  }

  handleRefreshTable() {
    this.loadCommissions()
    this.loadCompletedPayments()
  }

  openCity(evt, cityName) {
    var i, tabcontent, tablinks

    tabcontent = document.getElementsByClassName('tcontent')
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = 'none'
    }
    tablinks = document.getElementsByClassName('com-tab')
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace('active', '')
    }
    document.getElementById(cityName).style.display = 'block'
    evt.currentTarget.className += ' active'
  }

  loadCommissions() {
    this.isMakingPayment
      ? (this.isLoadingCommissions = false)
      : (this.isLoadingCommissions = true)

    this.requestService.dash_get(`commission`, null, true).subscribe((res) => {
      this.isLoadingCommissions = false
      let totalCommission = []
      res.data
        ? res.data.map((each) => {
            each.commission ? totalCommission.push(each.commission) : null
          })
        : null
      this.totalAmount = totalCommission.reduce((a, b) => a + b, 0)
      this.agentsCommissionsData = res.data
      this.agentsCommissionsDataFilter = res.data
    })
  }

  filterAgentCommissions(event) {
    this.searchItem = event.target.value

    this.agentsCommissionsData
      ? (this.agentsCommissionsDataFilter = this.agentsCommissionsData.filter(
          (data) =>
            data.va_name
              .toLowerCase()
              .indexOf(this.searchItem.toLowerCase()) !== -1
        ))
      : null
  }

  onDateRangeSelected() {
    if (this.rangeDates) {
      let startDate: string, endDate: string

      startDate = this.rangeDates[0]
        ? moment(this.rangeDates[0], 'YYYY-MM-DD').format('YYYY-MM-DD')
        : ''
      endDate = this.rangeDates[1]
        ? moment(this.rangeDates[1], 'YYYY-MM-DD').format('YYYY-MM-DD')
        : ''

      if (startDate && endDate) {
        this.calendar.overlayVisible = false
        this.paymentsDataFilter = this.paymentsData.filter(
          (data) =>
            new Date(data.created_at) >= new Date(startDate) &&
            new Date(data.created_at) <= new Date(endDate)
        )
      } else if (startDate && !endDate) {
        this.paymentsDataFilter = this.paymentsData.filter(
          (data) => data.created_at == startDate
        )
      }
    } else {
      this.paymentsDataFilter = this.paymentsData
    }
  }

  setSingleCommissionData(data: object) {
    this.singleAgentCommissionsData = data
    this.agentId = this.singleAgentCommissionsData.id
    this.agentsName = this.singleAgentCommissionsData.va_name
    this.agentMomoName = this.singleAgentCommissionsData.momoName
    this.agentMomoPhone = this.singleAgentCommissionsData.momoPhone
    this.commissionAmount = this.singleAgentCommissionsData.commission
  }

  closePaymentsModal() {
    jQuery(document).ready(() => {
      this.isMakingPayment = false
      jQuery('#payCommisssionModal').modal('hide')
    })
  }

  makePayment(makePaymentsForm) {
    const formData = new FormData()

    formData.append('id', this.agentId)
    formData.append('name', this.agentMomoName)
    formData.append('phone', this.agentMomoPhone)
    formData.append('amount', makePaymentsForm.amount)

    if (this.commissionAmount === makePaymentsForm.amount) {
      formData.append('totalCommissionAmount', makePaymentsForm.amount)
    }

    this.loading = true

    this.requestService.dash_post(`commission`, formData, true).subscribe(
      (res) => {
        this.loading = false
        if (res.success === true) {
          this.message = this.helperFunctions.capitalize(res.message)
          this.status = 'success'
          this.isMakingPayment = true
          this.loadCommissions()
          this.loadCompletedPayments()
          this.helperFunctions.displayAlert(this.message, this.status)
          this.closePaymentsModal()
        } else {
          this.message = 'Payment failed, please try again'
          this.status = 'error'
          this.isMakingPayment = false
          this.helperFunctions.displayAlert(this.message, this.status)
        }
      },
      (err) => {
        this.loading = false
        this.status = 'error'
        this.isMakingPayment = false
        this.message = 'An error occurred. Please try again'
        this.helperFunctions.displayAlert(this.message, this.status)
      }
    )
  }

  filterPayments(event) {
    this.searchItem = event.target.value

    this.paymentsData
      ? (this.paymentsDataFilter = this.paymentsData.filter(
          (data) =>
            data.va_name
              .toLowerCase()
              .indexOf(this.searchItem.toLowerCase()) !== -1
        ))
      : null
  }

  loadCompletedPayments() {
    this.isMakingPayment
      ? (this.isLoadingPayments = false)
      : (this.isLoadingPayments = true)

    this.requestService
      .dash_get(`commission/complete-payments`, null, true)
      .subscribe((res) => {
        this.isLoadingPayments = false
        let paymentTotal = []
        res.data
          ? res.data.map((each) => {
              each.commission ? paymentTotal.push(each.commission) : null
            })
          : null
        this.totalPayments = paymentTotal.reduce((a, b) => a + b, 0)
        this.paymentsData = res.data
        this.paymentsDataFilter = res.data
      })
  }

  setTransHistoryData(event, transactionType: string) {
    var i: number, tablinks

    if (transactionType === 'garden_mapping') {
      this.transactionHistoryDataFilter = this.transactionHistoryData =
        this.gardenMappingTransactions
      this.isPaymentTrans = false
      this.isGardenMappingTrans = true
    } else if (transactionType === 'payments') {
      this.transactionHistoryDataFilter = this.transactionHistoryData =
        this.paymentTransactions
      this.isPaymentTrans = true
      this.isGardenMappingTrans = false
    }

    tablinks = document.getElementsByClassName('trans-tab')
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace('active', '')
    }
    event.currentTarget.className += ' active'
  }

  loadTransactionHistory(data: object) {
    this.isLoadingTransHistory = true
    this.setSingleCommissionData(data)

    this.requestService
      .dash_get(
        `commission/transaction-history?vaId=${this.agentId}`,
        null,
        true
      )
      .subscribe((res) => {
        this.isLoadingTransHistory = false
        this.gardenMappingTransactions = res.data.filter(
          (each) => each.transactionType === 'garden_mapping'
        )
        this.isGardenMappingTrans = true
        this.transactionHistoryDataFilter = this.transactionHistoryData =
          this.gardenMappingTransactions
        this.paymentTransactions = res.data.filter(
          (each) => each.transactionType === 'payment'
        )
      })
  }

  closeHistoryModal() {
    this.isGardenMappingTrans = false
    this.isPaymentTrans = true
  }

  formatDate(date_: string) {
    const date = moment(date_, 'YYYY-MM-DD').format('DD/MM/YYYY')
    return date
  }

  onCheckedChange(event, data: object) {
    let checkStatus = event.target.checked

    if (checkStatus) {
      this.bulkPaymentsData.push(data)
    } else {
      let index = this.bulkPaymentsData.indexOf(data)
      if (index > -1) {
        this.bulkPaymentsData.splice(index, 1)
      }
    }
  }

  setCommissionPayments(commissionPayments): FormArray {
    const formArray = new FormArray([])
    commissionPayments
      ? commissionPayments.forEach((element) => {
          const commisionControl = this.fb.group({
            id: element.id,
            name: element.momoName,
            phone: element.momoPhone,
            amount: element.commission,
            totalCommissionAmount: element.commission,
          })
          commisionControl.valueChanges.subscribe(
            (val: { totalCommissionAmount: number; amount: number }) => {
              if (val.amount) {
                if (val.amount > val.totalCommissionAmount) {
                  commisionControl
                    .get('amount')
                    .setErrors({ amountError: true })
                } else {
                  commisionControl.get('amount').setErrors(null)
                }
              }
            }
          )
          formArray.push(commisionControl)
        })
      : null
    return formArray
  }

  setBulkPayData() {
    this.bulkPaymentForm.setControl(
      'bulk_payments',
      this.setCommissionPayments(this.bulkPaymentsData)
    )
  }

  makeBulkPayment() {
    const formData = new FormData()
    let bulkPayments = []

    this.bulkPaymentForm.value.bulk_payments.forEach((element) => {
      const isFullPayment = element.amount === element.totalCommissionAmount

      let paymentObject = {
        id: element.id,
        name: element.name,
        phone: element.phone,
        amount: element.amount,
        ...(isFullPayment
          ? { totalCommissionAmount: element.totalCommissionAmount }
          : {}),
      }
      bulkPayments.push(paymentObject)
    })

    formData.append('bulk_payments', JSON.stringify(bulkPayments))

    this.loading = true

    this.requestService
      .dash_post(`commission/bulk-payments`, formData, true)
      .subscribe(
        (res) => {
          this.loading = false
          if (res.success === true) {
            this.message = this.helperFunctions.capitalize(res.message)
            this.status = 'success'
            this.isMakingPayment = true
            this.loadCommissions()
            this.loadCompletedPayments()
            this.helperFunctions.displayAlert(this.message, this.status)
            this.bulkPaymentsData = []
            this.closeBulkPaymentsModal()
          } else {
            this.message = 'Payment failed, please try again'
            this.status = 'error'
            this.isMakingPayment = false
            this.helperFunctions.displayAlert(this.message, this.status)
          }
        },
        (err) => {
          this.loading = false
          this.status = 'error'
          this.isMakingPayment = false
          this.message = 'An error occurred. Please try again'
          this.helperFunctions.displayAlert(this.message, this.status)
        }
      )
  }

  closeBulkPaymentsModal() {
    jQuery(document).ready(() => {
      this.isMakingPayment = false
      jQuery('#bulkPayModal').modal('hide')
    })
  }

  onClickOutside() {
    jQuery(document).ready(() => {
      jQuery('#payCommisssionModal').on('hidden.bs.modal', () => {
        this.closePaymentsModal()
      })
      jQuery('#bulkPayModal').on('hidden.bs.modal', () => {
        this.closeBulkPaymentsModal()
      })
      jQuery('#transactionHistoryModal').on('hidden.bs.modal', () => {
        this.closeHistoryModal()
      })
    })
  }
}
